export default __webpack_public_path__ + "static/media/IconHandClosed.645eb3ef.svg";